import * as React from 'react';
import classNames from 'classnames';

import './styles.scss';

export interface ICollapsibleProps {
    /** Should collapsible be open or closed by default. */
    defaultOpen?: boolean;
    /** Class name to apply */
    className?: string;
    /** Layouts to choose from */
    layout?: 'default' | 'menu-item' | 'filter-group';
}

interface IState {
    open: boolean;
}

/**
 * Host for collapsible block. Children should be CollapsibleHeader and CollapsibleBody.
 */
export default class Collapsible extends React.Component<ICollapsibleProps, IState> {
    static displayName: string = 'Collapsible';

    constructor (props) {
        super(props);
        this.state = {
            open: props.defaultOpen ? props.defaultOpen : false,
        };
    }

    toggleOpen = (e) => {
        e.preventDefault();
        this.setState({
            open: !this.state.open,
        });
    };

    render () {
        return (
            <div className={classNames('collapsible', {
                'open': this.state.open,
                'layout-default': !this.props.layout || this.props.layout === 'default',
                'layout-menu-item': this.props.layout === 'menu-item',
                'layout-filter-group': this.props.layout === 'filter-group',
            }, this.props.className)}>
                {React.Children.map(this.props.children, (child) => {
                    if (typeof child === 'string' || typeof child === 'number' || child === null) {
                        return child;
                    } else {
                        if (React.isValidElement(child)) {
                            const extendedProps = {
                                open: this.state.open,
                                toggle: this.toggleOpen,
                                layout: this.props.layout,
                            };
                            return React.cloneElement(child, extendedProps);
                        }
                        return null;
                    }
                })}
            </div>
        );
    }
}
